import { oneDayInMs } from '@/composables/useTime';

export const WEIGHT_VOTE_DELAY = 1 * oneDayInMs;
